import clsx from "clsx";
import { IconProps } from "./dto";

export function ArrowLeftIcon(props: IconProps) {
    return (
        <svg className={clsx("", { "cursor-pointer": props.onClick })} width="20" height="20" viewBox="0 0 24 24" fill="none" onClick={props.onClick}>
            <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke={props.color || "#8383AD"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
